
<template>
  <div >
    <div style="width: 595px; height: 835px;">
      <img src="/page1.jpg" style="width:100%; height: 100%;position: relative;z-index:0;">
      <p style="top: 148px;left:90px;width:150px;">{{ intervention.client.lastname }}</p>
      <p style="top: 148px;left:320px;width:150px;">{{ intervention.client.firstname }}</p>

      <p style="top: 158px;left:95px;width:150px;">{{ intervention.client.address }}</p>
      <p style="top: 158px;left:330px;width:40px;">{{ intervention.client.zipcode }}</p>
      <p style="top: 158px;left:405px;width:100px;">{{ intervention.client.city }}</p>

      <p style="top: 664px;left:374px;width:100px;">{{ intervention.quote.date }}</p>
      <!-- <img :src="'https://api.hellodepann.fr/signature/'+intervention.quote.api_id+'.png'" style="top: 695px;left:241px;height:50px;width:150px;position: absolute;" v-if="intervention.quote.signature"> -->
    </div>
  </div>
</template>

<script>


export default {
  created () {
    
  },
  props: ['intervention'],
}
</script>

<style scoped>
  p {
    position: absolute;
    z-index: 1;
    font-size: 8px;
    font-weight: bold;
    color: #000;
  }
</style>
